<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('contacts')"
      :columns="columns"
      :column_search="true"
      resource_url="/central-dispatch-tracker/contact/datatables"
      mode="grid"
      grid_class="is-col-min-10"
    >
      <template #item="item">
        <div class="card product-card">
          <div class="card-image has-text-centered" style="padding-top: 1rem">
            <figure
              class="image is-96x96 m-auto product-image"
              @click="edit(item)"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/10751/10751432.png"
              />
            </figure>
            <div class="product-actions">
              <div class="field has-addons">
                <div class="control">
                  <button
                    class="button is-small"
                    :data-tooltip="$t('view')"
                    @click.stop="view(item)"
                  >
                    <span class="icon"
                      ><i class="fa fa-eye has-text-info"></i
                    ></span>
                  </button>
                </div>
                <div class="control">
                  <button
                    class="button is-small"
                    :data-tooltip="$t('delete')"
                    @click.stop="remove(item)"
                  >
                    <span class="icon"
                      ><i class="fa fa-trash has-text-danger"></i
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-content px-2 py-3" @click="edit(item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-6 has-text-centered mb-1">
                  {{ item.shipper?.companyName || "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:buttons> </template>
    </generic-table>
  </div>

  <contact-modal ref="contact_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  error_message,
  success_message,
  download,
  format_currency,
} from "@/utils";
import ContactModal from "./contact_modal/Index.vue";
import moment from "moment";

export default {
  name: "ContactDatatable",
  components: {
    GenericTable,
    ContactModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("data"),
          name: "data",
          searchable: false,
          width: "80%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete contact?"),
                    v,
                    () => {
                      del("/central-dispatch-tracker/contact", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    view(item) {
      let v = this;
      v.$refs.contact_modal.show(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete contact?"),
        v,
        () => {
          del("/central-dispatch-tracker/contact", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
};
</script>

<style></style>
